import { inject, Injectable } from '@angular/core';
import { _, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { LeakDetectionEventPositionService } from '@app/main/leak-detection/services/leak-detection-event-position/leak-detection-event-position.service';

@Injectable({ providedIn: 'root' })
export class LdContextMenuEventPositionService {
  private readonly translateService = inject(TranslateService);
  private readonly eventPosition = inject(LeakDetectionEventPositionService);

  public getMapItems(): MenuItem[] {
    const hasChanges = this.eventPosition.hasChanges();

    return [
      {
        label: this.translateService.instant(_(`@@shared-undo__text`)),
        icon: 'icons/icon-undo.svg',
        disabled: !hasChanges,
        command: () => this.eventPosition.undo(),
      },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-exit-change-position__label`)),
        icon: 'icons/icon-close.svg',
        command: () => this.eventPosition.requestExit(),
      },
      { separator: true },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-confirm-new-location__label`)),
        icon: 'icons/icon-done.svg',
        disabled: !hasChanges,
        command: () => this.eventPosition.confirm(),
      },
    ];
  }
}
